import { render, staticRenderFns } from "./change-zone-1.vue?vue&type=template&id=22d2eb8e&scoped=true&"
import script from "./change-zone-1.vue?vue&type=script&lang=js&"
export * from "./change-zone-1.vue?vue&type=script&lang=js&"
import style0 from "./change-zone-1.vue?vue&type=style&index=0&id=22d2eb8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d2eb8e",
  null
  
)

export default component.exports